import React, { useState } from 'react'
import Regeneration_Kratos from './Regeneration_Kratos';
import styles from './EnergyPageCustom_Kratos.module.css'
import Dcdc_Kratos from './Dcdc_Kratos';
import AUXInverterPrimary_Kratos from './AUXInverterPrimary_Kratos';
import AUXInverterSecondary_Kratos from './AUXInverterSecondary_Kratos';
import BattCoolingPrimarySecondary_Kratos from './BattCoolingPrimarySecondary_Kratos';
import HvacTotalDrive_Kratos from './HvacTotalDrive_Kratos';
import TractionSystem_Kratos from './TractionSystem_Kratos';

export default function Energy_Consumption_Breakdown(props) {
  let { gloablfilter } = props;
  const [defaultNav, setDefaultNav] = useState("dataRegen_kWh");

  function getNavTab(e, name) {
    setDefaultNav(name);
  }
  return (
    <div className='card p-2'>
      <div className={`v-title ${styles.energyTitleChart_Kratos} pt-2 pb-2 text-center`}>
        <b className=''>Energy Consumption Breakdown</b>
      </div>
      <div className="mt-1 mx-3">
        <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px" }}>
          <li className="nav-item">
            <a className="nav-link nav_in_line active" data-bs-toggle="tab" href="#Regeneration" onClick={(e) => getNavTab(e, "dataRegen_kWh")}>Regeneration</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#TractionSystem" onClick={(e) => getNavTab(e, "motorConsumption")}>TractionSystem</a>
          </li>
          {/* <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#HVAC" onClick={(e) => getNavTab(e, "acConsumption")}>HVAC</a>
          </li> */}
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#DCDC" onClick={(e) => getNavTab(e, "dcdcLoad")}>DCDC</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#AUX_Inverter_1" onClick={(e) => getNavTab(e, "aux1Load")}>AUX_Inverter_1</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#AUX_Inverter_2" onClick={(e) => getNavTab(e, "aux2Load")}>AUX_Inverter_2</a>
          </li>
           <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#Other_Sys" onClick={(e) => getNavTab(e, "remLoad")}>Other Sys.</a>
          </li>
          
          {/* <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#Batt_Cooling_1" onClick={(e) => getNavTab(e, "bcs1Load")}>Batt_Cooling_1</a>
          </li>
          <li className="nav-item">
            <a className="nav-link nav_in_line" data-bs-toggle="tab" href="#Batt_Cooling_2" onClick={(e) => getNavTab(e, "bcs2Load")}>Batt_Cooling_2</a>
          </li> */}
        </ul>
        <div className="tab-content">
          <div id="Regeneration" className="tab-pane active">
            <div className='row'>
              <Regeneration_Kratos gloablfilter={gloablfilter} modalName="Regeneration" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="TractionSystem" className="tab-pane fade">
            <div className='row'>
              <TractionSystem_Kratos gloablfilter={gloablfilter} modalName="TractionSystem" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="DCDC" className="tab-pane fade">
            <div className='row'>
              <Dcdc_Kratos gloablfilter={gloablfilter} modalName="DCDC" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="AUX_Inverter_1" className="tab-pane fade">
            <div className='row'>
              <AUXInverterPrimary_Kratos gloablfilter={gloablfilter} modalName="AUX_Inverter_1" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="AUX_Inverter_2" className="tab-pane fade">
            <div className='row'>
              <AUXInverterSecondary_Kratos gloablfilter={gloablfilter} modalName="AUX_Inverter_2" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="Other_Sys" className="tab-pane fade">
            <div className='row'>
              <AUXInverterPrimary_Kratos gloablfilter={gloablfilter} modalName="Other_Sys" itemSelected={defaultNav} />
            </div>
          </div>
          {/* <div id="HVAC" className="tab-pane fade">
            <div className='row'>
              <HvacTotalDrive_Kratos gloablfilter={gloablfilter} modalName="HVAC" itemSelected={defaultNav} />
            </div>
          </div> */}
          {/* <div id="Batt_Cooling_1" className="tab-pane fade">
            <div className='row'>
              <BattCoolingPrimarySecondary_Kratos gloablfilter={gloablfilter} modalName="Batt_Cooling_1" itemSelected={defaultNav} />
            </div>
          </div>
          <div id="Batt_Cooling_2" className="tab-pane fade">
            <div className='row'>
              <BattCoolingPrimarySecondary_Kratos gloablfilter={gloablfilter} modalName="Batt_Cooling_2" itemSelected={defaultNav} />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}
